import Client from '../HttpClient';

const baseUrl = '/gateway/kiwi-mgt/api/vs';

const list = (merchantId, branchId, page = 1, pageSize = 10000) => {
	return Client.get(`${baseUrl}/manage-invoice/invoices`, {
		merchantId,
		branchId,
		page,
		pageSize,
	});
};

const pdf = (id) => {
	return Client.get(
		`${baseUrl}/pdf-invoice/${id}`,
		{},
		{
			responseType: 'blob',
		}
	);
};

export default { list, pdf };
